<template>
    <!-- <div
      id="fbButton"
      class="validacion"
      v-bind:class="[isForResponsive]"
      @click="doLogin"
    >
      <span>LOGIN CON FACEBOOK</span>
      <img :src="facebook" style="width: 15px; margin-left: 10px;" />
    </div> -->
    <div class="age--form__inputs" v-bind:class="[isForResponsive]" @click="doLogin">
        <button type="button" class="age--form__fb--in" aria-label="Entrar FB">CLICK AQUÍ</button>
    </div>
</template>

<script>
import facebook from '@/assets/facebook.png';
import axios from 'axios';
import { sha256 } from 'js-sha256';
import tagFunctions from '@/utils/tagFunctions.js'

export default {
    name: "FacebookButtonAgeGates",
    data() {
        return {
            facebook
        };
    },
    props: {
        isForResponsive: null
    },

    methods: {
        // doLogin: function () {
        //     var vm = this;
        //     window.FB.login(
        //         (response) => {
        //             // console.log('response',response)
        //             // debugger
        //             if (response.status === "connected") {
        //                 const appsecret_proof = this.hmacHash(response.authResponse.accessToken, process.env.VUE_APP_API)
        //                 window.FB.api(
        //                     `/me?fields=birthday,email,name&appsecret_proof=${appsecret_proof}`,
        //                     async function (meResponse) {
        //                         // console.log(meResponse);
        //                         const xeerpaNeeded = {
        //                             ...response,
        //                             birthday: meResponse.birthday,
        //                         };
        //                         await vm.xeerpaRequest(xeerpaNeeded, meResponse.email)
        //                         meResponse.birthday
        //                             ? vm.$emit("fbLogin", xeerpaNeeded)
        //                             : vm.$emit("noBirthdayInFacebook");
        //                     }
        //                 );
        //             }
        //         },
        //         { scope: "public_profile,email,user_birthday" }
        //     );
        // },
        doLogin: function () {
            var vm = false;
            window.location.href = 'https://login.heinekenmexico.com/tecate00/'
        },
        async xeerpaRequest(response, email) {
            this.$emit('loading', true);
            const hash = sha256(email);
            const resp = await axios.get(` https://cuamoc.xeerpa.com:8443/discoveruser?clientId=6149a1372dfd6f0d347b6458&clientPwd=yyipHjnqJg&appId=63e0e618a94e170f88ad070d&socialNetwork=FB&userId=${response.authResponse.userID}&userToken=${response.authResponse.accessToken}&robinson=false&id=${hash}`);
            this.$emit("success", email);
            tagFunctions.evRegisterPush('Login con facebook');
            pintrk('track', 'signup', { property: 'RegistroConFacebook' });
            return resp
        },
        hmacHash(userToken, appSecret) {
            const hash = sha256.hmac.create(appSecret);
            const appsecret_proof = hash.update(userToken).hex();
            return appsecret_proof;
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/containers/agegatem.scss";
</style>